<template>
    <div class="ms-contact">
        <div class="ms-container" v-if="ll">
            <div class="ms-title">
                <h2 data-vl="10197">{{ll.i10197||'Contact us'}}</h2>
                <p data-vl="10198">{{ll.i10198||''}}</p>
            </div>
            <form class="ms-form">
                <div class="ms-form__input">
                    <input type="text" class="ms-input" :class="[errors.name ? 'erred' : '']" v-model="user.name" :placeholder="ll.i10199||'Enter your name'">
                </div>
                <div class="ms-form__wrap">
                    <div class="ms-form__wrap-item">
                        <input type="email" class="ms-input" :class="[errors.email ? 'erred' : '']" v-model="user.email" :placeholder="ll.i10200 || 'Enter your email'">
                    </div>
                    <div class="ms-form__wrap-item">
                        <div class="input-phone">
                            <template v-if="bindProps.defaultCountry">
                                <vue-tel-input
                                        :class="[errors.phone ? 'erred' : '']"
                                        v-model="user.phone"
                                        :preferredCountries="bindProps.preferredCountries"
                                        :defaultCountry="bindProps.defaultCountry"
                                        :placeholder="'Enter your phone'"
                                        @country-changed="countryChanged"
                                        @input="inputChange"
                                ></vue-tel-input>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="ms-form__input">
                    <textarea class="ms-input" :class="[errors.message ? 'erred' : '']" v-model="user.message" :placeholder="ll.i10201||'Please describe your issue or ask us a question'"></textarea>
                </div>
                <div class="ms-form__label">
                    <img src="img/check.svg" alt="">
                    <p data-vh="10202" v-html="t10202()"></p>
                </div>
                <div class="ms-form__btn">
                    <button class="btn-send" @click="send" type="button" data-vl="10203">{{ll.i10203||'Send'}}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { VueTelInput } from 'vue-tel-input'
    import 'vue-tel-input/dist/vue-tel-input.css'

    export default {
        name: "ContactUs",
        components: {
            VueTelInput
        },
        computed:{
            ll(){
                return this.$root.ll;
            }
        },
        data: function() {
            return{
                bindProps: {
                    mode: "international",
                    defaultCountry: null,
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: "Enter a phone number",
                    required: false,
                    enabledCountryCode: false,
                    enabledFlags: true,
                    preferredCountries: ["US", "GB"],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "on",
                    name: "Phone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    dropdownOptions: {
                        disabledDialCode: false
                    },
                    inputOptions: {
                        showDialCode: false
                    },
                    triggerLoad: false
                },
                user:{
                    name:'',
                    email:'',
                    phone: '',
                    message:'',
                    referrer:''
                },
                errors:{
                    name:'',
                    email:'',
                    phone: '',
                    message:''
                }
            }
        },
        methods: {
            async init(){
                await this.get_country();
            },
            countryChanged(event){
                if(this.user.phone.indexOf('100001')>-1){
                    this.$nextTick(() => {
                        this.user.phone = this.user.phone.replace('100001','');
                    });
                }
                //console.log('#popup-request', event)
                if(event && event.dialCode && this.user.phone.length<6 ){
                    this.$nextTick(() => {
                        this.user.phone = '+' + event.dialCode;
                    });
                    //this.$set(this.manager, 'u_tel', '+' + event.dialCode );
                }
            },
            clearPhone(phone){
                return phone.replace(/ /g,'').replace(/-/g,'');
            },
            inputChange(){
                if(this.user.phone=='') {
                    this.$nextTick(() => {
                        this.user.phone = '+';
                    });
                }
            },
            t10202(){
                return this.ll.i10202.replace('%s','<a href="/privacy-policy">').replace('%s','</a>');
            },
            async get_country(){
                let res = await axios.post('/api/main/get_country');
                if(res && res.data && res.data.result){
                    if(res.data.result.phone_code){
                        this.$root.user.phone_code = res.data.result.phone_code;
                        this.user.phone = res.data.result.phone_code;
                    }
                    if(res.data.result.country_code){
                        this.$root.user.country_code = res.data.result.country_code;
                        this.bindProps.defaultCountry = res.data.result.country_code.toUpperCase();
                    }
                    if(res.data.result.country) this.$root.user.country = res.data.result.country;
                }
            },
            async send(){

                let validate = false;
                let phoneValidate = false;


                if(this.user.phone && this.user.phone.trim()!=''){
                    let phoneNumber = this.user.phone.trim().replace(/ /g,"").replace(/\+/g,"");
                    let resPhoneValidate = await axios.get('/api/main/phone_validate?phone='+phoneNumber, {});
                    if(resPhoneValidate && resPhoneValidate.data && resPhoneValidate.data.valid) phoneValidate = true;
                }
                if(!phoneValidate){
                    this.errors.phone = true;
                    validate = true;
                }
                else{this.errors.phone = false;}

                if (this.user.name && this.user.name.trim() != '') {
                    this.errors.name = false;
                } else {
                    this.errors.name = true;
                    validate = true;
                }

                if (this.user.email && this.$root.validateEmail(this.user.email.trim())) {
                    this.errors.email = false;
                } else {
                    this.errors.email = true;
                    validate = true;
                }

                if(this.user.message && this.user.message.trim()!=''){
                    this.errors.message = false;
                }
                else{
                    this.errors.message = true;
                    validate = true;
                }

                if(validate) return;
                this.user.referrer = window.location.href;

                let res = await axios.post('/api/main/message', this.user);
                if(res && res.data && res.data.result){
                    this.$root.adata.show = true;
                    this.user.message = '';
                }
            }
        },
        mounted(){
            this.init();
        }
    }
</script>

<style lang="css">
    .vue-tel-input{
        background: #FFFFFF;
        width: 100%;
        min-height: 37px;
        border: 1px solid #D5E4F6!important;
        box-sizing: border-box;
        border-radius: 8px!important;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0.01em;
        color: #A8B6C7;
        font-family: Roboto,sans-serif;
        resize: vertical;
    }
    .vti__input {
        border-radius: 0 7px 7px 0;
    }
    .vue-tel-input.redError{
        border: 1px solid #e4486b!important;
    }
    input[type="text"].redError, input[type="email"].redError, input[type="password"].redError, textarea.redError{
        border: 1px solid #e4486b!important;
    }
    .vti__dropdown {
        width: 68px;
        background: #F9FCFE;
        border-right: 1px solid #C2CFE0;
        box-sizing: border-box;
        outline: none;
        border-radius: 5px 0px 0px 5px;
    }
    .vti__dropdown .vti__selection{
        text-align: left;
    }
    .request-form .input-form span.vti__selection{
        position: relative!important;
        right: unset!important;
    }
    .vti__dropdown.open, .vti__dropdown:hover {
        background-color: #fff!important;
        outline: none!important;
    }
    .vti__dropdown-item span{
        margin-right: 15px!important;
    }
    .vti__dropdown-list.below{
        top: 36px;
    }
    .input-select:before{
        top: 14px!important;
    }
    .vue-tel-input input.vti__input{
        padding-left: 11px!important;
    }
    .vti__dropdown-list{
        border: 1px solid rgba(165,181,203,0.7) !important;
        border-radius: 0;
        z-index: 4;
        -webkit-box-shadow: 0 5px 13px -2px rgba(0,0,0,0.2) !important;
        box-shadow: 0 5px 13px -2px rgba(0,0,0,0.2) !important;
        background-color: #FFFFFF;
        width: 360px;
    }
    .vti__dropdown-item{
        padding: 8px 33px 8px 15px
    }
    .vti__dropdown-item strong{
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #333!important;
        margin-left: 5px;
    }
    .vti__dropdown-arrow{
        right: -3px;
    }
    .erred{
        border: 1px solid #e4486b!important;
    }
</style>